<template>
	<div class="contracting">
		<div v-if="fetched && error === null" class="relative">
			<SystemError />
			<StateBar :steps="stateBarSteps" v-if="!getIsBusinessProcess" />
			<h2 class="fs-title text-center" v-if="!getIsBusinessProcess">{{ computedTitle }}</h2>
			<h3 class="fs-desc text-center max-w-755" v-html="$route.meta.desc" v-if="!getIsBusinessProcess"></h3>
			<router-view />
		</div>
		<LoadingLayer :show="!fetched && error === null" />
		<ErrorLayer :show="error !== null" :text="error" />
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import StateBar from '@/components/StateBarNew';
import LoadingLayer from '@/components/LoadingLayer';
import ErrorLayer from '@/components/ErrorLayer';
import _ from 'lodash';
import DataLayer from '@/helpers/dataLayer.js';
import SystemError from '@/components/SystemError';
import moment from 'moment';

export default {
	mounted() {
		DataLayer.setEvent('Szerzodo_adatai');
	},
	async beforeRouteEnter(to, _from, next) {
		next(async vm => {
			await vm.fetchCurrentUser();
			await vm.fetchOutbuildingTypes();
			await vm.fetchOutbuildingLocations();
			await vm.fetchCalculation(to.params.hash);

			if (!vm.getIsBusinessProcess && to.name !== 'contracting-base') {
			 	vm.$router.push({ name: 'contracting-base', params: to.params });
			}

            if(vm.getIsBusinessProcess && to.name !== 'contracting-statement')
            {
                 vm.$router.push({ name: 'contracting-statement', params: to.params });
            }

            if(vm.getIsBusinessProcess) {
                await vm.fetchIsSimpleRegistration({
                    hash: to.params.hash,
                    insurer_uuid: to.params.insurer_uuid,
                });
                await vm.fetchContract({hash: to.params.hash});
            }
            if(!vm.getIsCampaignCalculation && !vm.getCalculation.is_new_contract && !vm.getCalculation.on_my_own && moment(vm.getCalculation.old_start_of_risk).diff(moment().format('yyyy-MM-DD'), 'days') < 31) {
                vm.error = 'Nem köthető meg a szerződés a lejárt felmondási határidő miatt!';
            }

			if(moment(vm.getCalculation.start_of_risk).isSameOrBefore(moment().format('yyyy-MM-DD'))) {
                        if(vm.getIsBusinessProcess) {
                            vm.error = 'Nem köthető meg a szerződés a lejárt felmondási határidő kockázatviselés kezdet miatt, kérjük, vegye fel a kapcsolatot üzletkötőjével!';
                        } else {
                            await vm.$instances.popup.$children[0].$children[0].asyncShow('StartOfRiskChanger');
                        }
			}

			if (vm.getSelectedOffer === null) {
				await vm.calculate();
			}

			vm.fetched = true;

			if (vm.isLoggedIn) {
				if (!vm.isVerified) {
					vm.error = 'Kérlek aktiváld a fiókod!';
				}

				if (
					vm.getCurrentUser.id !== vm.getCalculation.user_id &&
					vm.getCalculation.consultant_id !== vm.getCurrentUser.id &&
					!vm.isAdmin &&
					!vm.isCustomerService
				) {
					vm.error = 'Ehhez a linkhez nincs hozzáférésed!';
				}
			} else {
				vm.popupHasClose(false);
                vm.showPopup('ContractingLogin');
			}

			vm.setSelectedOffer(vm.getOffer(to.params.insurer_uuid));
		});
	},
	components: {
		StateBar,
		LoadingLayer,
		ErrorLayer,
		SystemError,
	},
	data() {
		return {
			fetched: false,
			error: null,
		};
	},
	computed: {
		...mapGetters('auth', ['isLoggedIn', 'isVerified', 'getCurrentUser', 'isAdmin', 'isCustomerService']),
		...mapGetters('contracting', ['getSelectedOffer', 'getCheckboxData']),
		...mapGetters(['getOffer', 'getCalculation','getIsBusinessProcess', 'getIsCampaignCalculation']),
		computedTitle() {
			return this.isGenAndInsuredData(this.$route.name) ? 'Biztosítottak adatai' : this.$route.meta.title;
		},
		isGenAndInsuredData() {
			return routeName => this.getSelectedOffer.insurer_code === 'GEN' && routeName === 'contracting-insured';
		},
		stateBarSteps() {
			return _.map(this.$router.options.routes[1].children, child => {
				return {
					title: this.isGenAndInsuredData(child.name) ? 'Biztosítottak adatai' : child.meta.title,
					route: child.name,
					params: this.$route.params,
					disabled: this.isStepDisabled(child.name),
				};
			});
		},
		isStepDisabled() {
			return route => {
                if(this.getIsBusinessProcess)
                    return true;

				if (route === 'contracting-insured') {
					return this.getSelectedOffer.insurer_code === 'GEN'
						? false
						: !this.getCheckboxData('differentInsuredData');
				}

				if (route === 'contracting-financing') {
					return !this.getCalculation.real_estate.mortgage;
				}

				return false;
			};
		},
	},
	methods: {
		...mapActions(['fetchCalculation', 'calculate', 'fetchOutbuildingTypes', 'fetchOutbuildingLocations']),
		...mapActions('auth', ['fetchCurrentUser','fetchIsSimpleRegistration']),
        ...mapActions('contracting',['fetchContract']),
		...mapMutations('contracting', ['setSelectedOffer']),
		...mapMutations(['showPopup', 'popupHasClose']),
	},
};
</script>
